/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2020 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/fr';
import 'moment/locale/zh-cn';

const textMonths = ['01','02','03','04','05','06','07','08','09','10','11','12'];

export const useDates = () => {

    const getDateInfo = (date) => {
        date = date ? moment(date) : moment();
        return {
            // primary
            year: date.year(),
            month: date.month() + 1,
            day: date.date(),
            hour: date.hour(),
            minute: date.minute(),
            second: date.second(),
            millisecond: date.millisecond(),
            // other
            dayOfWeek: date.weekday(),
            dayOfYear: date.dayOfYear(),
            textMonth: textMonths[date.month()]
        };
    };
    const getFormattedDate = (value, format, language) => {
        const date = moment(value);
        return date.locale(language).format(format);
    };

    const isLeapYear = (year) => {
        return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0);
    };

    const getMonthName = (date, locale = 'en') => {
        return moment(date).locale(locale).format('MMMM');
    };

    return { getDateInfo, isLeapYear, getFormattedDate, getMonthName };

};